import React from 'react';

import Audits from '@/reports/audits';

const Reports = () => {
  return <Audits />;
};

export default Reports;
